import React, { useState, useEffect } from "react";

export default function Moreport() {
  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
  });

  const [errors, setErrors] = useState({
    startDate: "",
    endDate: "",
    dateComparison: "",
  });

  const [isFormValid, setIsFormValid] = useState(false);

  const [showErrors, setShowErrors] = useState(false);

  // Validate form whenever formData changes
  useEffect(() => {
    validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {
      startDate: "",
      endDate: "",
      dateComparison: "",
    };

    if (!formData.startDate) {
      newErrors.startDate = "Start date is required";
    }
    if (!formData.endDate) {
      newErrors.endDate = "End date is required";
    }

    if (formData.startDate && formData.endDate) {
      if (new Date(formData.endDate) < new Date(formData.startDate)) {
        newErrors.dateComparison = "End date must be greater than start date";
      }
    }

    // Only update isFormValid, don't set errors yet
    const isValid = Object.values(newErrors).every((error) => error === "");
    setIsFormValid(isValid);
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowErrors(true);
    const currentErrors = validateForm();
    setErrors(currentErrors);

    if (Object.values(currentErrors).every((error) => error === "")) {
      // Add your form submission logic here
      console.log("Form submitted:", formData);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="box">
              <div className="box-header">
                <div className="row">
                  <div className="col-md-8">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb breadcrumb_bg">
                        <li className="breadcrumb-item">
                          <a className="breadcrumb_1">Manage Reports</a>
                        </li>
                        <li
                          className="breadcrumb-item active breadcrumb_2"
                          aria-current="page"
                        >
                          MO Report
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-md-4 mt_3">
                    <div className="btn-group float-right">
                      <input
                        type="button"
                        className="btn btn-primary btn-raised btn-flat"
                        value="Download Report"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="box-body">
                <form className="mt-2" onSubmit={handleSubmit} noValidate>
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          Select Start Date<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            showErrors && errors.startDate ? "is-invalid" : ""
                          }`}
                          name="startDate"
                          value={formData.startDate}
                          onChange={handleInputChange}
                        />
                        {showErrors && errors.startDate && (
                          <div className="invalid-feedback d-block">
                            {errors.startDate}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          Select End Date<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            showErrors && errors.endDate ? "is-invalid" : ""
                          }`}
                          max={new Date().toISOString().split("T")[0]}
                          name="endDate"
                          value={formData.endDate}
                          onChange={handleInputChange}
                          min={formData.startDate}
                        />
                        {showErrors && errors.endDate && (
                          <div className="invalid-feedback d-block">
                            {errors.endDate}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2 mt-auto">
                      <div className="form-group">
                        <label className="font-weight-bold invisible">
                          Select Date
                        </label>
                        <button
                          type="submit"
                          className="form-control btn btn-primary"
                          disabled={!isFormValid}
                        >
                          Submit
                        </button>
                        {showErrors && errors.dateComparison && (
                          <div className="text-danger mt-1">
                            {errors.dateComparison}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
                <div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li
                      className="nav-item position-relative"
                      role="presentation"
                    >
                      <a
                        className="nav-link active"
                        id="home-tab"
                        data-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Mo Details
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active pt-2"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <table
                        id="Sub_table"
                        className="table table-bordered table-striped table-sm tableWidth"
                      >
                        <thead>
                          <tr className="table-info">
                            <th>CP Name</th>
                            <th>Short Code</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Total Count</th>
                            <th>MO Price</th>
                            <th>Total Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ wordBreak: "break-all" }}>name</td>
                            <td style={{ wordBreak: "break-all" }}>4</td>
                            <td style={{ wordBreak: "break-all" }}>19-11-23</td>
                            <td style={{ wordBreak: "break-all" }}>19-11-23</td>
                            <td style={{ wordBreak: "break-all" }}>1</td>
                            <td style={{ wordBreak: "break-all" }}>
                              Rs 45,000
                            </td>
                            <td style={{ wordBreak: "break-all" }}>
                              Rs 2,56,999
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
